export default {
  title: 'Marken-Sync — Marken',
  subtitle:
    'Übersicht über alle Restaurants der Gruppe und ihre synchronisierten Funktionen. Nur der Account-Admin kann Änderungen vornehmen.',
  alert: {
    message: 'Nur für Admins',
    description:
      'Änderungen am Master-Menü, an Preisen und Angeboten können nur vom Account-Admin vorgenommen werden. Alle Standorte erhalten Updates automatisch.',
  },
  locations: {
    title: 'Standorte',
    description: 'Alle Restaurants der Gruppe, die das Master-Menü und die Einstellungen teilen',
    locations_zero: '0 Standorte',
    locations_one: '1 Standort',
    locations_other: '{{count}} Standorte',
    synced: 'Synchronisiert',
  },
  features: {
    title: 'Synchronisierte Funktionen',
    description: 'Diese Funktionen werden durch die Master-Einstellungen gesteuert',
    menus: {
      title: 'Master-Menü',
      desription: 'Menüeinträge, Kategorien und Beschreibungen werden über alle Standorte hinweg synchronisiert',
    },
    smart_pricing: {
      title: 'Smart Pricing',
      desription: 'Preisregeln und Anpassungen werden über alle Standorte hinweg synchronisiert',
    },
    offers: {
      title: 'Angebote & Promotionen',
      desription: 'Aktive Angebote, Rabatte und Promotionen werden über alle Standorte hinweg synchronisiert',
    },
  },
};
